<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g id="Group_819" data-name="Group 819" transform="translate(-24 -361)">
      <rect
        id="Rectangle_907"
        data-name="Rectangle 907"
        width="16"
        height="16"
        transform="translate(24 361)"
        fill="none"
      />
      <g id="_037-open" data-name="037-open" transform="translate(-147 277)">
        <g id="Group_817" data-name="Group 817" transform="translate(163 76)">
          <path
            id="Path_377"
            data-name="Path 377"
            d="M18.139,19.8a1.78,1.78,0,0,1-1.528-.742l-.611-1-.611,1a1.78,1.78,0,0,1-1.528.742H9.883v2.917a.39.39,0,0,0,.367.341l5.647.933a.682.682,0,0,0,.1.009h.012a.938.938,0,0,0,.1-.009l5.647-.933a.388.388,0,0,0,.361-.341V19.8Z"
          />
          <path
            id="Path_378"
            data-name="Path 378"
            d="M22.875,18.867H18.137a.484.484,0,0,1-.415-.2l-2.136-3.5a.285.285,0,0,1,.057-.366.54.54,0,0,1,.455-.123l5.651.933a.439.439,0,0,1,.334.222L23.306,18.4a.281.281,0,0,1-.055.32A.515.515,0,0,1,22.875,18.867Z"
          />
          <path
            id="Path_379"
            data-name="Path 379"
            d="M13.863,18.867H9.125a.513.513,0,0,1-.375-.149.28.28,0,0,1-.055-.32l1.223-2.567a.439.439,0,0,1,.334-.222l5.651-.933a.542.542,0,0,1,.455.123.284.284,0,0,1,.057.366l-2.136,3.5a.487.487,0,0,1-.416.2Z"
          />
        </g>
        <g id="Group_818" data-name="Group 818" transform="translate(163 76)">
          <path
            id="Path_380"
            data-name="Path 380"
            d="M16,13.333a.667.667,0,0,1-.667-.667v-4a.667.667,0,0,1,1.334,0v4A.667.667,0,0,1,16,13.333Z"
          />
          <path
            id="Path_381"
            data-name="Path 381"
            d="M16,13.333a.666.666,0,0,1-.406-.138l-2.167-1.667a.667.667,0,1,1,.813-1.057L16,11.825l1.76-1.354a.667.667,0,0,1,.813,1.057L16.406,13.2A.666.666,0,0,1,16,13.333Z"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "request-icon",
};
</script>

<style scoped></style>
